import type { TNoteColor } from 'shared/ui/Note/Note';

export interface INoteLink {
  type: 'phone' | 'external';
  label: string;
  href: string;
  title?: string;
}

export interface IOfferNoteText {
  title: string;
  description?: string;
  color: TNoteColor;
  buttonLabel?: string;
  linkTitle?: string;
}

export interface IOfferNoteTextsConfig {
  microCredit: {
    approved: IOfferNoteText;
    accepted: IOfferNoteText;
    issued: IOfferNoteText;
    refused: IOfferNoteText;
    alreadySent: IOfferNoteText;
    mfo: IOfferNoteText;
  };
  credit: {
    preapproved: IOfferNoteText;
    approved: IOfferNoteText;
    accepted: IOfferNoteText;
    issued: IOfferNoteText;
    refused: IOfferNoteText;
    alreadySent: IOfferNoteText;
    alreadySentOtkritie: IOfferNoteText;
  };
  queued: IOfferNoteText;
  fake: IOfferNoteText;
  autoPledge: IOfferNoteText;
  propertyPledge: IOfferNoteText;
}

type OfferNoteTextsFDConfig = {
  queued: IOfferNoteText;
  accepted: IOfferNoteText;
  approved: IOfferNoteText;
  preapproved: IOfferNoteText;
  refused: IOfferNoteText;
  alreadySent: IOfferNoteText;
  issued: IOfferNoteText;
};

export const OFFER_NOTE_TEXTS: IOfferNoteTextsConfig = {
  microCredit: {
    approved: {
      title: 'Заявка одобрена',
      description: undefined,
      color: 'green',
    },
    accepted: {
      title: 'Заявка принята',
      description: 'Вы узнаете решение по вашей заявке в течение 3-10 минут',
      color: 'blue',
    },
    issued: {
      title: 'Микрокредит одобрен',
      description: 'Перейдите в личный кабинет партнера, чтобы указать реквизиты для получения денег',
      color: 'green',
    },
    refused: {
      title: 'Заявка отклонена',
      description: 'Отправьте больше заявок в другие МФО, чтобы повысить шанс на получение займа',
      color: 'orange',
    },
    alreadySent: {
      title: 'У вас уже есть активная заявка на займ в этом МФО',
      description: 'Уточните детали активной заявки в МФО по телефону',
      color: 'orange',
    },
    mfo: {
      title: '',
      description: undefined,
      color: 'orange',
    },
  },
  credit: {
    preapproved: {
      title: 'Кредит предварительно одобрен',
      description: 'C вами свяжется сотрудник банка, чтобы уточнить условия.',
      linkTitle: 'Номер телефона банка:',
      color: 'green',
    },
    approved: {
      title: 'Кредит одобрен',
      description: 'C вами свяжется сотрудник банка, чтобы уточнить условия.',
      linkTitle: 'Номер телефона банка:',
      color: 'green',
    },
    accepted: {
      title: 'Банк принял заявку',
      description: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия.',
      color: 'blue',
      buttonLabel: 'Перейти ко всем заявкам',
    },
    issued: {
      title: 'Кредит был выдан',
      description: 'Актуальные условия указаны в вашем кредитном договоре',
      color: 'orange',
    },
    refused: {
      title: 'Банк отказал',
      description:
        'Повторно отправить заявку можно будет через 30 дней. А пока вы можете рассмотреть другие предложения.',
      color: 'orange',
    },
    alreadySent: {
      title: 'У вас уже есть активная заявка на кредит в этом банке',
      description: 'Уточните детали активной заявки в банке по телефону',
      color: 'orange',
    },
    alreadySentOtkritie: {
      title: 'У вас уже есть активная заявка на кредит в этом банке',
      description:
        'Вы уже отправляли заявку в банк «Открытие». Дождитесь звонка сотрудника или позвоните на горячую линию для уточнения статуса вашей заявки',
      color: 'orange',
    },
  },
  queued: {
    title: 'Банк обрабатывает вашу заявку',
    description: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия.',
    linkTitle: 'Номер телефона банка:',
    color: 'dark',
  },
  fake: {
    title: 'Низкая вероятность одобрения',
    color: 'orange',
  },
  autoPledge: {
    title: 'Предоставьте информацию об автомобиле перед отправкой заявки',
    color: 'dark',
  },
  propertyPledge: {
    title: 'Предоставьте информацию о недвижимости перед отправкой заявки',
    color: 'dark',
  },
};

export const OFFER_NOTE_TEXTS_FD: OfferNoteTextsFDConfig = {
  queued: {
    title: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия',
    color: 'dark',
  },
  accepted: {
    title: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия.',
    color: 'dark',
  },
  approved: {
    title: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия',
    color: 'dark',
  },
  preapproved: {
    title: 'Сегодня с вами свяжется сотрудник банка, чтобы уточнить условия',
    color: 'dark',
  },
  refused: {
    title: 'Банк не готов одобрить сейчас кредит. Отправить новую заявку можно будет позже',
    color: 'orange',
  },
  alreadySent: {
    title: 'У вас уже есть заявка на кредит в этом банке. Узнать подробности можно в банке или по телефону',
    color: 'dark',
  },
  issued: {
    title: 'Поздравляем, вы оформили этот кредит! Актуальные условия вы можете найти в своём кредитном договоре',
    color: 'dark',
  },
};
